export default __webpack_public_path__ + "static/media/MasterCard.6fd4ae10.svg";